import {
  USER_REJECT_MOBILE_DOWNLOAD_POPUP,
  USER_ACCEPT_MOBILE_DOWNLOAD_POPUP,
  INITIAL_MOBILE_POPUP,
} from '@/store/actions/mobilePopup';
/**
 * Сколько раз демонстрировать попап.
 * В случае если пользователь не согласился установить приложение.
 *
 * @type {number}
 */
const MAX_SHOW_POPUP = 2;

/**
 * Интервал показа в днях
 *
 * @type {number}
 */
const INTERVAL_DAY_SHOW = 1;

const defaultPopupData = {
  count: 0,
  is_show: true,
  last_show: Date.now(),
};

const popupProvider = {
  getPopup() {
    return JSON.parse(window.localStorage.getItem('mobile-download-popup'));
  },
  setPopup(value) {
    window.localStorage.setItem('mobile-download-popup', JSON.stringify(value));
  },
};

const state = {
  popup: popupProvider.getPopup(),
};

const getters = {
  getMobileDownloadPopup: () => state.popup,
};

const actions = {
  [USER_REJECT_MOBILE_DOWNLOAD_POPUP]: ({ commit }) => {
    commit(USER_REJECT_MOBILE_DOWNLOAD_POPUP);
    popupProvider.setPopup(state.popup);
  },
  [USER_ACCEPT_MOBILE_DOWNLOAD_POPUP]: ({ commit }) => {
    commit(USER_ACCEPT_MOBILE_DOWNLOAD_POPUP);
    popupProvider.setPopup(state.popup);
  },
  [INITIAL_MOBILE_POPUP]: ({ commit }) => {
    commit(INITIAL_MOBILE_POPUP);
  },
};
const methods = {
  /**
   * Определяем, показываем или нет, поп ап.
   *
   * @return {void}
   */
  defineIsShow() {
    const date = new Date(state.popup.last_show);
    date.setDate(date.getDate() + INTERVAL_DAY_SHOW);
    const isCountExpression = state.popup.count < MAX_SHOW_POPUP;
    if (isCountExpression) {
      state.popup.is_show = date < Date.now();
      return;
    }
    state.popup.is_show = false;
  },
};

const mutations = {
  [USER_REJECT_MOBILE_DOWNLOAD_POPUP]: () => {
    state.popup.count += 1;
    state.popup.is_show = false;
    popupProvider.setPopup(state.popup);
  },
  [USER_ACCEPT_MOBILE_DOWNLOAD_POPUP]: () => {
    state.popup.count = MAX_SHOW_POPUP;
    state.popup.is_show = false;
    popupProvider.setPopup(state.popup);
  },
  [INITIAL_MOBILE_POPUP]: () => {
    if (!state.popup) {
      popupProvider.setPopup(defaultPopupData);
      state.popup = defaultPopupData;
      return;
    }
    methods.defineIsShow();
  },
};

export default () => ({
  state,
  getters,
  actions,
  mutations,
});
